import { render, staticRenderFns } from "./ScreenToggle.vue?vue&type=template&id=5925833d&scoped=true&"
import script from "./ScreenToggle.vue?vue&type=script&lang=js&"
export * from "./ScreenToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5925833d",
  null
  
)

export default component.exports